import { DownloadOutlined } from '@ant-design/icons';
import { Breadcrumb, Button, Input, Table, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import "./PreviewSendForApproval.css";
import { useTranslation } from 'react-i18next';
import { getRequest } from '../../axios';
import { ErrorNotificationMsg } from '../../utils/Notifications';
const { Title } = Typography;

function PreviewSendForApproval() {
  const { t } = useTranslation();

  const { id } = useParams();
  const [comparativesRFQ, setComparativesRFQ] = useState([]);
  const [rfqNumber, setRfqNumber] = useState(null);

    const [size, setSize] = useState('large');
    const onChange = (text) => {
        console.log('onChange:', text);
    };
    // const sharedProps = {
    //     onChange,
    // };


    const res = [
        { 
        
             "id": 515,
             "rfq_number": "00464",
             "summery_of_price_comparative": [
                 {
                     "select_city_id": 1,
                     "select_city_name": "Ahmedabad",
                     "site_wise_data": [
                         {
                             "rfq_vendor_detail_id": 1223,
                             "site_id": 85,
                             "site_name": "Satellite",
                             "vendor_wise_data": [
                                 {
                                     "vendor_id": 184,
                                     "vendor_name": "Puma",
                                     "material_wise_data": [
                                         {
                                             
                                             "material_name": "OPC 43",
                                             "total_quantity_by_material": 23.0,
                                             "material_uom": "Bag",
                                             "r_price": [
                                                 {
                                                     "r_unit_price": 4.0,
                                                     "r_total_price": 100.0
                                                 } 
                                             ],
                                         },
                                         {
                                             
                                             "material_name": "OPC 53",
                                             "total_quantity_by_material": 10.0,
                                             "material_uom": "MT",
                                             "r_price": [
                                                 {
                                                     "r_unit_price": 10.0,
                                                     "r_total_price": 200.0
                                                 } 
                                             ],
                                         },
                                         {
                                             
                                             "material_name": "PPC",
                                             "total_quantity_by_material": 3.0,
                                             "material_uom": "Ton",
                                             "r_price": [
                                                 {
                                                     "r_unit_price": 7.0,
                                                     "r_total_price": 130.0
                                                 } 
                                             ],
                                         },
                                         {
                                             
                                             "material_name": "RMC",
                                             "total_quantity_by_material": 10.0,
                                             "material_uom": "Bag",
                                             "r_price": [
                                                 {
                                                     "r_unit_price": 40.0,
                                                     "r_total_price": 65.0
                                                 } 
                                             ],
                                         },
                                     ],
                                    
                                 },
                              
                             ],
                             "site_wise_sub_total": [
                                 {
                                     "vendor_id": 184,
                                     "sub_total": 69.0,
                                     "site_id": 85
                                 },
   
                               ]
                         
                         },
                         {
                             "rfq_vendor_detail_id": 1225,
                             "site_id": 86,
                             "site_name": "Gota",
                             "vendor_wise_data": [
                                 {
                                     "vendor_id": 184,
                                     "vendor_name": "OM",
                                     "material_wise_data": [
                                         {
                                             
                                             "material_name": "OPC 43",
                                             "total_quantity_by_material": 46.0,
                                             "material_uom": "MT",
                                             "r_price": [
                                                 {
                                                     "r_unit_price": 40.0,
                                                     "r_total_price": 140.0
                                                 } 
                                             ],
                                         },
                                         {
                                             
                                             "material_name": "OPC 53",
                                             "total_quantity_by_material": 60.0,
                                             "material_uom": "MT",
                                             "r_price": [
                                                 {
                                                     "r_unit_price": 40.0,
                                                     "r_total_price": 90.0
                                                 } 
                                             ],
                                         },
                                         {
                                             
                                             "material_name": "PPC",
                                             "total_quantity_by_material": 13.0,
                                             "material_uom": "Ton",
                                             "r_price": [
                                                 {
                                                     "r_unit_price": 70.0,
                                                     "r_total_price": 30.0
                                                 } 
                                             ],
                                         },
                                         {
                                             
                                             "material_name": "RMC",
                                             "total_quantity_by_material": 3.0,
                                             "material_uom": "MT",
                                             "r_price": [
                                                 {
                                                     "r_unit_price": 36.0,
                                                     "r_total_price": 40.0
                                                 } 
                                             ],
                                         },
                                     ],
                                    
                                 },
                              
                             ],
                             "site_wise_sub_total": [
                                 {
                                     "vendor_id": 184,
                                     "sub_total": 169.0,
                                     "site_id": 85
                                 },
                            
   
                               ]
                         },
 
 
                     
                     ],
                   //   "city_wise_sub_total": [
                   //     {
                   //       {
                   //         "vendor_id": 184,
                   //         "city_sub_total": 600.0,
                   //         "site_id": 85
                   //     },
                   //         "city_sub_total": 600.0,
                   //         // "city_site_id": 1
                   //     },
                   // ]
                   "city_wise_sub_total": [
                     {
                         "vendor_id": 184,
                         "city_sub_total": 800.0,
                         "site_id": 85
                     },
                   
                 ],
                 },
                 {
                     "select_city_id": 2,
                     "select_city_name": "Bangalore",
                     "site_wise_data": [
                         {
                             "rfq_vendor_detail_id": 1223,
                             "site_id": 85,
                             "site_name": "BTM",
                             "vendor_wise_data": [
                                 {
                                     "vendor_id": 184,
                                     "vendor_name": "Puma",
                                     "material_wise_data": [
                                         {
                                             
                                             "material_name": "OPC 43",
                                             "total_quantity_by_material": 6.0,
                                             "material_uom": "Bag",
                                             "r_price": [
                                                 {
                                                     "r_unit_price": 5.0,
                                                     "r_total_price": 10.0
                                                 } 
                                             ],
                                         },
                                         {
                                             
                                             "material_name": "OPC 53",
                                             "total_quantity_by_material": 30.0,
                                             "material_uom": "MT",
                                             "r_price": [
                                                 {
                                                     "r_unit_price": 10.0,
                                                     "r_total_price": 200.0
                                                 } 
                                             ],
                                         },
                                         {
                                             
                                             "material_name": "PPC",
                                             "total_quantity_by_material": 63.0,
                                             "material_uom": "Ton",
                                             "r_price": [
                                                 {
                                                     "r_unit_price": 27.0,
                                                     "r_total_price": 30.0
                                                 } 
                                             ],
                                         },
                                         {
                                             
                                             "material_name": "RMC",
                                             "total_quantity_by_material": 40.0,
                                             "material_uom": "Bag",
                                             "r_price": [
                                                 {
                                                     "r_unit_price": 90.0,
                                                     "r_total_price": 350.0
                                                 } 
                                             ],
                                         },
                                     ],
                                    
                                 },
                              
                             ],
                             "site_wise_sub_total": [
                                 {
                                     "vendor_id": 184,
                                     "sub_total": 690.0,
                                     "site_id": 85
                                 },
                      
   
                               ]
                         
                         },
                         {
                             "rfq_vendor_detail_id": 1225,
                             "site_id": 86,
                             "site_name": "Ring Road",
                             "vendor_wise_data": [
                                 {
                                     "vendor_id": 184,
                                     "vendor_name": "OM",
                                     "material_wise_data": [
                                         {
                                             
                                             "material_name": "OPC 43",
                                             "total_quantity_by_material": 6.0,
                                             "material_uom": "MT",
                                             "r_price": [
                                                 {
                                                     "r_unit_price": 49.0,
                                                     "r_total_price": 40.0
                                                 } 
                                             ],
                                         },
                                         {
                                             
                                             "material_name": "OPC 53",
                                             "total_quantity_by_material": 30.0,
                                             "material_uom": "MT",
                                             "r_price": [
                                                 {
                                                     "r_unit_price": 20.0,
                                                     "r_total_price": 60.0
                                                 } 
                                             ],
                                         },
                                         {
                                             
                                             "material_name": "PPC",
                                             "total_quantity_by_material": 36.0,
                                             "material_uom": "Ton",
                                             "r_price": [
                                                 {
                                                     "r_unit_price": 25.0,
                                                     "r_total_price": 168.0
                                                 } 
                                             ],
                                         },
                                         {
                                             
                                             "material_name": "RMC",
                                             "total_quantity_by_material": 23.0,
                                             "material_uom": "MT",
                                             "r_price": [
                                                 {
                                                     "r_unit_price": 6.0,
                                                     "r_total_price": 90.0
                                                 } 
                                             ],
                                         },
                                     ],
                                    
                                 },
                              
                             ],
                             "site_wise_sub_total": [
                                 {
                                     "vendor_id": 184,
                                     "sub_total": 369.0,
                                     "site_id": 85
                                 },
                            
   
                               ]
                         },
 
 
                     
                     ],
                   //   "city_wise_sub_total": [
                   //     {
                   //       {
                   //         "vendor_id": 184,
                   //         "city_sub_total": 600.0,
                   //         "site_id": 85
                   //     },
                   //         "city_sub_total": 600.0,
                   //         // "city_site_id": 1
                   //     },
                   // ]
                   "city_wise_sub_total": [
                     {
                         "vendor_id": 184,
                         "city_sub_total": 400.0,
                         "site_id": 85
                     },
                   
                 ],
                 },
             ]
         }
     
     ]
 
 
 
     console.log('res ', res);
 
 
 
 
   useEffect(() => {
     const getVendorBidRFQ = async () => {
       try {
         const response = await getRequest(`comparative-rfq/515/get-summery-of-price-comparative/`);
         console.log('response 125', response)
         if (response.data.data) {
           console.log('01 '); 
           // const responseData = response?.data?.data?.site_wise_data;
         const responseData = response?.data?.data?.summery_of_price_comparative;
         console.log('responseData 5', responseData);
         
         // const tableData = response?.data?.data?.summery_of_price_comparative?.map((item, index) => {
             console.log('res 120 ', res[0]);
         const tableData = res[0]?.summery_of_price_comparative?.map((item, index) => {
         console.log('item 66 ', item);
           return {
           key: item.select_city_id,
           cityName: item.select_city_name,
           cityTotal: item.city_wise_sub_total.map((city, index) => {
             return { vendorId: city.vendor_id, citySubTotal: city.city_sub_total };
         }),
           comparative: item.site_wise_data.map((com, ind) => {
             console.log('com 55', com, 'ind ', ind);
 
               return {
                   siteName: com.site_name,
 
                   vendorWise: com.vendor_wise_data.map((it, index) => {
                     console.log('it 2 ', it);
                     return {
                         vendorName : it.vendor_name,
                         siteLocations: it.material_wise_data.map((item1, index) => {
                             return {
                                 materialName:item1.material_name,
                                 quantity: item1.total_quantity_by_material,
                                 uom: item1.material_uom,
                                 r_unit_price: item1.r_price[0].r_unit_price,
                                 r_total_price: item1.r_price[0].r_total_price,
                             }
                         }),
                     }
                 }),
                 siteId: com.site_id,
                 siteTotal: com.site_wise_sub_total[0].sub_total || 0,
               };
           }),
         }});
       
           console.log('tableData', tableData); 
           setComparativesRFQ(tableData);
 
           setRfqNumber(response.data.data.id);
     //       const sites = response.data.data.site_wise_data.map(item => ({
     //         id: item.site_id,
     //         name: item.site_name
     //       }));
     //       setSiteName(sites);
           
           
           
           
     //       const materialTypes = response.data.data.site_wise_data.flatMap(item =>
     //         item.material_wise_data.map(material => ({
     //           id: material.rfq_material_type_id,
     //           name: material.material_name
     //         }))
     //       );
           
     //       const uniqueMaterialTypes = materialTypes.filter((material, index, self) =>
     //         index === self.findIndex(m => m.id === material.id && m.name === material.name)
     //       );
           
           
     //       setMaterialName(uniqueMaterialTypes);
           
 
 
 
         } else {
           ErrorNotificationMsg(t("Error in Comparatives"));
         }
       } catch (error) {
         console.error("Error:", error);
       }
     };
     getVendorBidRFQ();
   }, [id]);


   console.log('comparativesRFQ:', comparativesRFQ);

   const data = comparativesRFQ.flatMap((item, index) => {
    console.log('item ', item, 'index ', index);
    let citySubTotal = item.cityTotal[0]?.citySubTotal || 0;
    return (
       item.comparative.flatMap((comparative, compIndex) => {
        console.log('comparative ', comparative, 'compIndex ', compIndex);
        return (
           comparative.vendorWise.flatMap((vendor, vendorIndex) => {
               console.log('vendor:', vendor, 'vendorIndex ', vendorIndex);
               return vendor.siteLocations.flatMap((location, locationIndex) => {
                   console.log('location:', location, 'locationIndex ', locationIndex);
                   return ([
                       {
                           key: `${index}-${compIndex}-${vendorIndex}-${locationIndex}`,
                           'Sr.No': locationIndex === 0 && compIndex === 0 ? <Input disabled value={index + 1} className='InputNO' /> : null,
                           City: locationIndex === 0 && compIndex === 0 ? <Input disabled value={item.cityName} className='InputCity' /> : null,
                           'Site Name': locationIndex === 0 ? <Input disabled value={comparative.siteName} className='InputSite' /> : null,
                           'Vendor Name': locationIndex === 0 ? vendor.vendorName || '' : null,
                           Items: <Input disabled value={location.materialName || ''} className='InputItem' />,
                           Quantity: <Input disabled value={location.quantity || ''} className='InputNO' />,
                           UOM: <Input disabled value={location.uom || ''} className='InputUOM' />,
                           'Unit Rate': <Input disabled value={`\u20B9 ${location.r_unit_price || 0}`} className='InputUnit' />,
                           'Total Amount': <Input disabled value={`\u20B9 ${location.r_total_price || 0}`} className='InputUnit' />,
                       },
                       locationIndex === vendor.siteLocations.length - 1 && {
                           key: `${index}-${compIndex}-${vendorIndex}-SubTotal`,
                           'Site Name': 'Sub-Total',
                           'Total Amount': <Input disabled value={`\u20B9 ${comparative.siteTotal || 0}`} className='InputUnit' />,
                       },
                       locationIndex === vendor.siteLocations.length - 0 && compIndex === 1 && {
                            'Site Name': 'City-sub-Total',
                            'Total Amount': <Input disabled value={`\u20B9 ${item.cityTotal.citySubTotal || 0}`} className='InputUnit' />,     
                       }
                   ]);
               },
               
            );
           },
        
        )
       )}
    ).concat({
        key: `${index}-CitySubTotal`,
        'Site Name': 'City-sub-Total',
        'Total Amount': <Input disabled value={`\u20B9 ${citySubTotal}`} className='InputUnit' />,
    })
   )}
);
   
   console.log('data:', data);
   




    const columns = [
        {
            title: 'Sr.No',
            dataIndex: 'Sr.No',
        },
        {
            title: 'City',
            dataIndex: 'City',
        },
        {
            title: 'Site Name',
            dataIndex: 'Site Name',
        },
        {
            title: 'Vendor Name',
            dataIndex: 'Vendor Name',
            width: 200,
        },
        {
            title: 'Items',
            dataIndex: 'Items',
        },
        {
            title: 'Quantity',
            dataIndex: 'Quantity',
        },
        {
            title: 'UOM',
            dataIndex: 'UOM',
        },
        {
            title: 'Unit Rate',
            dataIndex: 'Unit Rate',
        },
        {
            title: 'Total Amount',
            dataIndex: 'Total Amount',
        },
    ];
    // const data = [
    //     {
    //         key: '1',
    //         'Sr.No': <Input disabled value={"1"} className='InputNO' />,
    //         City: <Input disabled value={"Ahmendabad"} className='InputCity' />,
    //         'Site Name': <Input disabled value={"Site 1"} className='InputSite' />,
    //         'Vendor Name': 'SANGHI INDUSTRIES LTD THROUGH ACC',
    //         Items: <Input disabled value={"OPC 43"} className='InputItem' />,
    //         Quantity: <Input disabled value={"20"} className='InputNO' />,
    //         UOM: <Input disabled value={"MT"} className='InputUOM' />,
    //         'Unit Rate': <Input disabled value={"\u20B9 100"} className='InputUnit' />,
    //         'Total Amount': <Input disabled value={"\u20B9 2000"} className='InputUnit' />,
    //     },
    //     {
    //         key: '2',
    //         'Sr.No': '',
    //         City: '',
    //         'Site Name': '',
    //         'Vendor Name': '',
    //         Items: <Input disabled value={"OPC 43"} className='InputItem' />,
    //         Quantity: <Input disabled value={"20"} className='InputNO' />,
    //         UOM: <Input disabled value={"MT"} className='InputUOM' />,
    //         'Unit Rate': <Input disabled value={"\u20B9 50"} className='InputUnit' />,
    //         'Total Amount': <Input disabled value={"\u20B9 500"} className='InputUnit' />,
    //     },
    //     {
    //         key: '4',
    //         'Sr.No': '',
    //         City: '',
    //         'Site Name': '',
    //         'Vendor Name': '',
    //         Items: <Input disabled value={"PPC"} className='InputItem' />,
    //         Quantity: <Input disabled value={"20"} className='InputNO' />,
    //         UOM: <Input disabled value={"MT"} className='InputUOM' />,
    //         'Unit Rate': <Input disabled value={"\u20B9 30"} className='InputUnit' />,
    //         'Total Amount': <Input disabled value={"\u20B9 300"} className='InputUnit' />,
    //     },
    //     {
    //         key: '5',
    //         'Sr.No': '',
    //         City: '',
    //         'Site Name': '',
    //         'Vendor Name': '',
    //         Items: <Input disabled value={"RMC"} className='InputItem' />,
    //         Quantity: <Input disabled value={"20"} className='InputNO' />,
    //         UOM: <Input disabled value={"MT"} className='InputUOM' />,
    //         'Unit Rate': <Input disabled value={"\u20B9 20"} className='InputUnit' />,
    //         'Total Amount': <Input disabled value={"\u20B9 200"} className='InputUnit' />,
    //     },
    //     {
    //         key: '6',
    //         'Site Name': 'Sub-Total',
    //         'Total Amount': <Input disabled value={"\u20B9 55000"} className='InputUnit' />,
    //     },
    //     {
    //         key: '7',
    //         'Sr.No': '',
    //         City: '',
    //         'Vendor Name': 'SHREE DIGVIJAY CEMENT CO. LTD',
    //         Items: <Input disabled value={"OPC 43"} className='InputItem' />,
    //         Quantity: <Input disabled value={"20"} className='InputNO' />,
    //         UOM: <Input disabled value={"MT"} className='InputUOM' />,
    //         'Unit Rate': <Input disabled value={"\u20B9 100"} className='InputUnit' />,
    //         'Total Amount': <Input disabled value={"\u20B9 2000"} className='InputUnit' />,
    //     },
    //     {
    //         key: '8',
    //         'Sr.No': '',
    //         City: '',
    //         'Site Name': '',
    //         'Vendor Name': '',
    //         Items: <Input disabled value={"OPC 43"} className='InputItem' />,
    //         Quantity: <Input disabled value={"20"} className='InputNO' />,
    //         UOM: <Input disabled value={"MT"} className='InputUOM' />,
    //         'Unit Rate': <Input disabled value={"\u20B9 50"} className='InputUnit' />,
    //         'Total Amount': <Input disabled value={"\u20B9 500"} className='InputUnit' />,
    //     },
    //     {
    //         key: '9',
    //         'Sr.No': '',
    //         City: '',
    //         'Site Name': '',
    //         'Vendor Name': '',
    //         Items: <Input disabled value={"PPC"} className='InputItem' />,
    //         Quantity: <Input disabled value={"20"} className='InputNO' />,
    //         UOM: <Input disabled value={"MT"} className='InputUOM' />,
    //         'Unit Rate': <Input disabled value={"\u20B9 30"} className='InputUnit' />,
    //         'Total Amount': <Input disabled value={"\u20B9 300"} className='InputUnit' />,
    //     },
    //     {
    //         key: '10',
    //         'Sr.No': '',
    //         City: '',
    //         'Site Name': '',
    //         'Vendor Name': '',
    //         Items: <Input disabled value={"RMC"} className='InputItem' />,
    //         Quantity: <Input disabled value={"20"} className='InputNO' />,
    //         UOM: <Input disabled value={"MT"} className='InputUOM' />,
    //         'Unit Rate': <Input disabled value={"\u20B9 20"} className='InputUnit' />,
    //         'Total Amount': <Input disabled value={"\u20B9 200"} className='InputUnit' />,
    //     },
    //     {
    //         key: '11',
    //         'Site Name': 'Sub-Total',
    //         'Total Amount': <Input disabled value={"\u20B9 55000"} className='InputUnit' />,
    //     },
    //     {
    //         key: '12',
    //         'Site Name': 'City-sub-Total',
    //         'Total Amount': <Input disabled value={"\u20B9 110000"} className='InputUnit' />,
    //     },
    //     {
    //         key: '13',
    //         'Sr.No': <Input disabled value={"2"} className='InputNO' />,
    //         City: <Input disabled value={"Rajkot"} className='InputCity' />,
    //         'Site Name': <Input disabled value={"Site 1"} className='InputSite' />,
    //         'Vendor Name': 'SANGHI INDUSTRIES LTD THROUGH ACC',
    //         Items: <Input disabled value={"OPC 43"} className='InputItem' />,
    //         Quantity: <Input disabled value={"20"} className='InputNO' />,
    //         UOM: <Input disabled value={"MT"} className='InputUOM' />,
    //         'Unit Rate': <Input disabled value={"\u20B9 100"} className='InputUnit' />,
    //         'Total Amount': <Input disabled value={"\u20B9 2000"} className='InputUnit' />,
    //     },
    //     {
    //         key: '14',
    //         'Sr.No': '',
    //         City: '',
    //         'Site Name': '',
    //         'Vendor Name': '',
    //         Items: <Input disabled value={"OPC 43"} className='InputItem' />,
    //         Quantity: <Input disabled value={"20"} className='InputNO' />,
    //         UOM: <Input disabled value={"MT"} className='InputUOM' />,
    //         'Unit Rate': <Input disabled value={"\u20B9 50"} className='InputUnit' />,
    //         'Total Amount': <Input disabled value={"\u20B9 500"} className='InputUnit' />,
    //     },
    //     {
    //         key: '15',
    //         'Sr.No': '',
    //         City: '',
    //         'Site Name': '',
    //         'Vendor Name': '',
    //         Items: <Input disabled value={"PPC"} className='InputItem' />,
    //         Quantity: <Input disabled value={"20"} className='InputNO' />,
    //         UOM: <Input disabled value={"MT"} className='InputUOM' />,
    //         'Unit Rate': <Input disabled value={"\u20B9 30"} className='InputUnit' />,
    //         'Total Amount': <Input disabled value={"\u20B9 300"} className='InputUnit' />,
    //     },
    //     {
    //         key: '16',
    //         'Sr.No': '',
    //         City: '',
    //         'Site Name': '',
    //         'Vendor Name': '',
    //         Items: <Input disabled value={"RMC"} className='InputItem' />,
    //         Quantity: <Input disabled value={"20"} className='InputNO' />,
    //         UOM: <Input disabled value={"MT"} className='InputUOM' />,
    //         'Unit Rate': <Input disabled value={"\u20B9 20"} className='InputUnit' />,
    //         'Total Amount': <Input disabled value={"\u20B9 200"} className='InputUnit' />,
    //     },
    //     {
    //         key: '17',
    //         'Site Name': 'Sub-Total',
    //         'Total Amount': <Input disabled value={"\u20B9 55000"} className='InputUnit' />,
    //     },
    //     {
    //         key: '18',
    //         'Sr.No': '',
    //         City: '',
    //         'Site Name': '',
    //         'Vendor Name': '',
    //         'Site Name': <Input disabled value={"Site 1"} className='InputSite' />,
    //         'Vendor Name': 'SHREE DIGVIJAY CEMENT CO. LTD',
    //         Items: <Input disabled value={"OPC 43"} className='InputItem' />,
    //         Quantity: <Input disabled value={"20"} className='InputNO' />,
    //         UOM: <Input disabled value={"MT"} className='InputUOM' />,
    //         'Unit Rate': <Input disabled value={"\u20B9 100"} className='InputUnit' />,
    //         'Total Amount': <Input disabled value={"\u20B9 2000"} className='InputUnit' />,
    //     },
    //     {
    //         key: '19',
    //         'Sr.No': '',
    //         City: '',
    //         'Site Name': '',
    //         'Vendor Name': '',
    //         Items: <Input disabled value={"OPC 43"} className='InputItem' />,
    //         Quantity: <Input disabled value={"20"} className='InputNO' />,
    //         UOM: <Input disabled value={"MT"} className='InputUOM' />,
    //         'Unit Rate': <Input disabled value={"\u20B9 50"} className='InputUnit' />,
    //         'Total Amount': <Input disabled value={"\u20B9 500"} className='InputUnit' />,
    //     },
    //     {
    //         key: '20',
    //         'Sr.No': '',
    //         City: '',
    //         'Site Name': '',
    //         'Vendor Name': '',
    //         Items: <Input disabled value={"PPC"} className='InputItem' />,
    //         Quantity: <Input disabled value={"20"} className='InputNO' />,
    //         UOM: <Input disabled value={"MT"} className='InputUOM' />,
    //         'Unit Rate': <Input disabled value={"\u20B9 30"} className='InputUnit' />,
    //         'Total Amount': <Input disabled value={"\u20B9 300"} className='InputUnit' />,
    //     },
    //     {
    //         key: '21',
    //         'Sr.No': '',
    //         City: '',
    //         'Site Name': '',
    //         'Vendor Name': '',
    //         Items: <Input disabled value={"RMC"} className='InputItem' />,
    //         Quantity: <Input disabled value={"20"} className='InputNO' />,
    //         UOM: <Input disabled value={"MT"} className='InputUOM' />,
    //         'Unit Rate': <Input disabled value={"\u20B9 20"} className='InputUnit' />,
    //         'Total Amount': <Input disabled value={"\u20B9 200"} className='InputUnit' />,
    //     },
    //     {
    //         key: '22',
    //         'Sr.No': '',
    //         City: '',
    //         'Site Name': '',
    //         'Vendor Name': '',
    //         'Site Name': 'Sub-Total',
    //         'Total Amount': <Input disabled value={"\u20B9 55000"} className='InputUnit' />,
    //     },
    //     {
    //         key: '23',
    //         'Site Name': 'City-sub-Total',
    //         'Total Amount': <Input disabled value={"\u20B9 110000"} className='InputUnit' />,
    //     },
    // ];

    

    return (
        <>
            <div className='Container'>
                <div className="ListingTopBar">
                    <div className="pagenamewrap">
                        <div className="pagename">
                            <h3>Preview and Send for Approval</h3>
                            <Breadcrumb className="Breadcrumb-Sec">
                                <Breadcrumb.Item>
                                    <Link to="">Home</Link>
                                </Breadcrumb.Item>
                                <Breadcrumb.Item>
                                    Preview and Send for Approval
                                </Breadcrumb.Item>
                            </Breadcrumb>
                        </div>
                    </div>
                </div>
                <div className="Main">
                    <div className='firstPortion'>
                        <div className='InputRFQ'>
                            <h3>RFQ Number: </h3>
                            <h4 className='RFQnumber'>{"RFQ-C01-001"}</h4>
                        </div>
                        <div className='Button'>
                            <Button type="primary" icon={<DownloadOutlined />} size={size}>
                                Download
                            </Button>
                        </div>
                    </div>
                    <div className="Tabel">
                        <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            pagination={false}
                            className="custom-table"
                        />
                    </div>
                    <div className='TotalAMT'>
                        <h4>Total Amount: </h4>
                        <Input disabled value={"\u20B9 115000"} className='InputTotal' />
                    </div>
                    <div className='SendForApproval'>
                        <Button type="primary" size={size}>
                            Send For Approval
                        </Button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PreviewSendForApproval
